import React, { Component } from 'react';
import './Info.css';

class Info extends Component {
	render() {
		return <div id="info">
			<p>Andy's World is a website for collecting images. Every once in a while images are selected for the front page. Click the upload button to choose photos from your computer or phone. You can also drag and drop or ⌘C + ⌘V to upload images faster.</p>
        </div>
	}
}

export default Info;


// WEBPACK FOOTER //
// ./src/Info.js